// extracted by mini-css-extract-plugin
export var sliderRange = "_qu-2";
export var sliderRoot = "_qu-0";
export var sliderThumb = "_qu-3";
export var sliderTrack = "_qu-1";